import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ScanRunDTO, ScanFonte } from '@central/types';

interface ScansResponse {
  runs: ScanRunDTO[];
  total: number;
}

export function useScans(): UseQueryResult<ScansResponse> {
  return useQuery({
    queryKey: ['scans'],
    queryFn: () => api<ScansResponse>('/api/scans?limit=100'),
    refetchInterval: 30_000,
  });
}

export interface ScanResult {
  scanRunId: number;
  fonte: ScanFonte;
  status: 'success' | 'partial' | 'failed' | 'skipped';
  duracaoMs: number;
  novos: number;
  atualizados: number;
  desaparecidos: number;
  erros: number;
  skipReason?: string;
}

export function useRunScan(): ReturnType<
  typeof useMutation<ScanResult | { results: ScanResult[] }, Error, string>
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fonte: string) =>
      api<ScanResult | { results: ScanResult[] }>(`/api/scans/run/${fonte}`, { method: 'POST' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['scans'] });
      qc.invalidateQueries({ queryKey: ['items'] });
      qc.invalidateQueries({ queryKey: ['alerts'] });
    },
  });
}
